import React from 'react';
import './navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Link, NavLink } from 'react-router-dom';
import './index';

function Navbar() {
  const navLinks = () => {
    return (
      <ul className='navbar-nav ml-auto mr-5'>
        {/* Use NavLink instead of Link */}
        <li className='nav-item'>
          <NavLink exact to='/' className='nav-link navbar-navlink'>
            home
          </NavLink>
        </li>
        <li className='nav-item'>
          <NavLink to='/about' className='nav-link navbar-navlink'>
            about
          </NavLink>
        </li>
        <li className='nav-item'>
          <NavLink to='/portfolio' className='nav-link navbar-navlink'>
            portfolio
          </NavLink>
        </li>
        <li className='nav-item'>
          <NavLink to='/contact' className='nav-link navbar-navlink'>
            contact
          </NavLink>
        </li>
      </ul>
    );
    // return (
    //   <ul className='navbar-nav ml-auto mr-5'>
    //     <li className='nav-item active'>
    //       <Link to='/' className='nav-link navbar-navlink'>
    //         home<span className='sr-only'>(current)</span>
    //       </Link>
    //     </li>
    //     <li className='nav-item'>
    //       <Link to='/about' className='nav-link navbar-navlink'>
    //         about
    //       </Link>
    //     </li>

    //     <li className='nav-item'>
    //       <Link to='/portfolio' className='nav-link navbar-navlink'>
    //         portfolio
    //       </Link>
    //     </li>

    //     <li className='nav-item'>
    //       <Link to='/contact' className='nav-link navbar-navlink'>
    //         contact
    //       </Link>
    //     </li>
    //   </ul>
    // );
  };

  return (
    <nav id='nav' className='navbar navbar-expand-sm bg-dark'>
      <div className='container'>
        <NavLink to='/' className='navbar-brand'>
         MARSIYA ISSAH
        </NavLink>

        {/* <Link to='/' className='navbar-brand'> */}
        {/* <img
						src="https://res.cloudinary.com/dytnpjxrd/image/upload/c_scale,h_40,w_140/v1614020557/my_logo_adfpkf.png"
						alt="mylogo"
						className="logo"
					/> */}
        {/* SIYA
        </Link> */}

        <button
          className='btn navbar-toggler'
          type='button'
          data-bs-toggle='offcanvas'
          data-bs-target='#offcanvasWithBackdrop'
          aria-controls='offcanvasWithBackdrop'
        >
          <FontAwesomeIcon icon={faBars} style={{ color: '#c4932f' }} />
        </button>

        <div
          className='offcanvas offcanvas-start'
          tabIndex='-1'
          id='offcanvasWithBackdrop'
          aria-labelledby='offcanvasWithBackdropLabel'
        >
          <div className='offcanvas-body'>{navLinks()}</div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
